// extracted by mini-css-extract-plugin
export default {"container":"style_container__2AgFU","tableDIV":"style_tableDIV__V+GvK"};